export const formatDate = (date) => {
  const dateSplit = date.split(' ');
  return `${dateSplit[0]} ${dateSplit[1]} - ${dateSplit[4]}`;
};
